/* @flow */
import React, { useState, type Node } from 'react';
import { useSelector } from 'react-redux';
import {
	Section,
	TitleH2,
	ServicesBtnWrapper,
	ServicesButton,
	ServicesContent,
	ServicesItem,
	ServicesWrapper,
} from '../styles';
import { Container } from '../../../components/Layout/styles';
import {
	TitleWrapper,
	ServicesTitle,
	ServicesSubtitle,
	ServicesPrice,
	ServicesList,
	ListItem,
	TopWrapper,
	ServicesStatus,
} from './styles';
import Button from '../../../components/Button2.0';
import { serviceCheckIcon, serviceTypePackage } from '../../../components/Icons';
import { formatValuesNumber } from '../../../utils/formatting';
import type { TCity } from '../../../types/city';
import type { TServices, TServicesItem } from '../../../types/services';
import Label from '../../../components/Label';

const Services = ({ innerRef }: Node) => {
	const isMobile: boolean = useSelector((state) => state.app.isMobile);
	const city: TCity = useSelector((state) => state.city);
	const servicesState: TServices = useSelector((state) => state.services);

	const {
		data: { services },
		isLoaded,
	} = servicesState;

	const [isActive, setIsActive] = useState('buy');

	const handleClick = (mode) => {
		setIsActive(mode);
	};

	const currentGroup = isActive === 'buy' ? 1 : 2;
	const currentCity =
		city.link === 'spb' || city.link === 'msk' || city.link === 'nsk' || city.link === 'kzn' ? city.link : 'other';

	if (isLoaded)
		return (
			<Section id="SectionPackage" type="package" ref={innerRef}>
				<Container>
					<TitleH2 isCenter>{isMobile ? 'Услуги покупки и продажи квартир' : 'Услуги'}</TitleH2>
					<ServicesBtnWrapper role="tablist">
						<ServicesButton role="tab" isActive={isActive === 'buy'} onClick={() => handleClick('buy')}>
							Купить {!isMobile && 'квартиру'}
						</ServicesButton>
						<ServicesButton role="tab" isActive={isActive === 'sell'} onClick={() => handleClick('sell')}>
							Продать {!isMobile && 'квартиру'}
						</ServicesButton>
					</ServicesBtnWrapper>
					<ServicesContent count={2}>
						{services?.map(
							(item: TServicesItem) =>
								item.groupId === currentGroup &&
								item.package && (
									<ServicesItem key={item.id} id={`services${item.id}`}>
										<ServicesWrapper>
											<TopWrapper>
												{item?.hit && <ServicesStatus>Хит</ServicesStatus>}
												<Label icon={serviceTypePackage}>Пакетные услуги</Label>
											</TopWrapper>
											<TitleWrapper>
												<ServicesTitle>{item.title}</ServicesTitle>
												<ServicesPrice>
													{formatValuesNumber(
														item.prices[currentCity].pricePostpayment ??
															item.prices[currentCity].pricePrepayment,
														'rub',
													)}
												</ServicesPrice>
											</TitleWrapper>
											<ServicesSubtitle>{item.descriptionShort}</ServicesSubtitle>
											<ServicesList>
												{item.descriptionList.map((element: string, idx: number) => (
													<ListItem key={idx.toString()}>
														<svg>{serviceCheckIcon}</svg>
														<p>{element}</p>
													</ListItem>
												))}
											</ServicesList>
											<Button
												color="secondary"
												size="s"
												style={{ marginTop: 'auto' }}
												isLink
												to={`/${city.link}/service/${item.code}/`}
											>
												Подробнее
											</Button>
										</ServicesWrapper>
									</ServicesItem>
								),
						)}
					</ServicesContent>
				</Container>
			</Section>
		);
	return null;
};
export default Services;
